// Helper: Format > Check if convertible to URL
function checkIfConvertibleToURL (value) {
	if (!value) return false
	let url
	try {
		url = new URL(decodeURIComponent(value)) // Decode in case the URL is encoded
	} catch (error) {
		return false
	}
	return url.protocol === 'http:' || url.protocol === 'https:'
}

// Helper: Format > Check if URL
function checkIfURL (value) {
	if (!value) return false
	let url
	try {
		url = new URL(value)
	} catch (error) {
		return false
	}
	return url.protocol === 'http:' || url.protocol === 'https:'
}

// Helper: Format > Obfuscate API key
function obfuscateAPIKey (key) {
	if (!key) return null
	return `${
		key.slice(0,4)
	}${
		Array(8)
			.fill('*')
			.join('')
	}${
		key.slice(-4)
	}`
}

// Export
export {
	checkIfConvertibleToURL,
	checkIfURL,
	obfuscateAPIKey
}
